import React from 'react';
import { theme } from 'theme';
import { GenerateType } from 'models/Activity';
import AudioIcon from '../../../../assets/icons/pathway/AudioIcon';
import TaskIcon from '../../../../assets/icons/pathway/TaskIcon';
import strings from '../../../../strings/strings.json';
import { ButtonClickHandler } from 'components/buttons/ButtonStyle';
import Button from 'components/buttons/Button';

export type GenerateButtonProps = {
    generatedType: GenerateType;
    onClick: ButtonClickHandler;
    disableButton: boolean;
};
export function GenerateButton({ generatedType, onClick, disableButton }: GenerateButtonProps): JSX.Element {
    let buttonTitle = '';
    let buttonAria = '';
    let icon = <></>;

    switch (generatedType) {
        case GenerateType.TEXT_TO_AUDIO:
        default:
            buttonTitle = strings.courseAIGeneratedContentComponent.generateButton.textToAudio.title;
            buttonAria = strings.courseAIGeneratedContentComponent.generateButton.textToAudio.aria;
            icon = <AudioIcon colour={theme.cardBackground} />;
            break;
        case GenerateType.AUDIO_TO_TEXT:
            buttonTitle = strings.courseAIGeneratedContentComponent.generateButton.audioToText.title;
            buttonAria = strings.courseAIGeneratedContentComponent.generateButton.audioToText.aria;
            icon = <TaskIcon colour={theme.cardBackground} interiorColour={theme.primaryButtonBackgroundColour} />;
            break;
        case GenerateType.VIDEO_TO_TEXT:
            buttonTitle = strings.courseAIGeneratedContentComponent.generateButton.videoToText.title;
            buttonAria = strings.courseAIGeneratedContentComponent.generateButton.videoToText.aria;
            icon = <TaskIcon colour={theme.cardBackground} interiorColour={theme.primaryButtonBackgroundColour} />;
            break;
    }
    return (
        <Button
            title={buttonTitle}
            aria={buttonAria}
            onClick={onClick}
            submitting={disableButton}
            icon={<div>{icon}</div>}
            fullwidth
            colour='PRIMARY'
        />
    );
}
